const constantsLoans = {
	canAccessSimplicIntegratedFlow: "CAN_ACCESS_SIMPLIC_INTEGRATED_FLOW",
	canAccessNoverdeIntegratedFlow: "CAN_ACCESS_NOVERDE_INTEGRATED_FLOW",
	canAccessSupersimIntegratedFlow: "CAN_ACCESS_SUPERSIM_INTEGRATED_FLOW",
};

export default constantsLoans;
